var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiljBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "miljo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.65 67.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "ac314e3a-17e1-4755-99df-d81eb03e6113",
    "data-name": "border",
    d: "M2,63.75A11.3,11.3,0,0,1,.28,60.23c-.36-1.16,2.53-3.13,2.53-3.13l0-39.86A10.27,10.27,0,0,1,.37,12.35C0,9.62,1,7.35,2.81,6.57s5.3-4,8-5.2,9.12.68,9.73,1S24.4.83,28.34.29s9,4.89,10.27,6.28-.51,6.2-3.36,6.63-2,.8-2.74,3.07-7.38,3.91-7.38,3.91V33.77h27.1V58.16H54.4v5.61H52.77v3.4H2.68S2.54,64.24,2,63.75Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiljBorder);
export default __webpack_public_path__ + "static/media/miljö-border.1cebe372.svg";
export { ForwardRef as ReactComponent };